import { Component, input } from '@angular/core';

@Component({
  selector: 'app-account-header',
  templateUrl: './account-header.component.html',
  styleUrls: ['./account-header.component.scss'],
})
export class AccountHeaderComponent {
  readonly email = input<string>();
  readonly customerNumber = input<string>();
}
